import { useQuery } from "@tanstack/react-query";
import { EntityType } from "@repo/types/enums";
import type { EntityDTO } from "../../types/dtos";
import type { RecordId } from "@repo/types/ui/tables";
import { entityKeys } from "@repo/types/queries";
import { useApiAccess } from "@repo/hooks/contexts";

export function useGetEntityById(entityType: EntityType, entityId: RecordId) {
  const { apiClient } = useApiAccess();

  return useQuery({
    queryKey: entityKeys.details(`${entityType}-${entityId ?? ""}`),
    queryFn: async () => {
      const response = await apiClient.get<EntityDTO>(
        `/entity/get?entityType=${entityType}&entityId=${entityId}`,
      );
      return response.data;
    },
    enabled: !!entityId && !!entityType,
  });
}
